import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=035636d7&scoped=true"
import script from "./FooterContact.vue?vue&type=script&lang=js"
export * from "./FooterContact.vue?vue&type=script&lang=js"
import style0 from "./FooterContact.vue?vue&type=style&index=0&id=035636d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035636d7",
  null
  
)

export default component.exports